import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import {
  speedTest,
  initiateMic,
  initiateWebCam,
  browserTest,
} from "../../utils/sys_utils";
import { useHistory } from "react-router-dom";
import { addRoute } from "../../redux/features/candidate/candidateAuthSlice";
import { useDispatch } from "react-redux";
import SpinnerStatus from "../spinner_status/spinner_status";
import { ReactComponent as InfoCircle } from "../../images/info-circle.svg";
import { ReactComponent as MicIcon } from "../../images/mic.svg";
import { ReactComponent as VideoIcon } from "../../images/video.svg";
import { ReactComponent as BrowserIcon } from "../../images/browser.svg";
import { ReactComponent as InternetIcon } from "../../images/internet.svg";

import "./system_check.scss";

const SystemCheck = () => {
  const dispatch = useDispatch()
  
  const [webCamStatus, setWebCamStatus] = useState({
    webCam: "loading",
    finished: false,
  });
  const [internetStatus, setInternetStatus] = useState({
    internet: "loading",
    finished: false,
  });
  const [micStatus, setMicStatus] = useState({
    mic: "loading",
    finished: false,
  });
  const [browserStatus, setBrowserStatus] = useState({
    browser: "loading",
    finished: false,
  });
  const [error, setError] = useState({
    mic: "",
    internet: "",
    browser: "",
    webCam: "",
  });
  const [values, setValues] = useState({
    mic: "",
    internet: "",
    browser: "",
    webCam: "",
  });
  const [reset, setReset] = useState(false);
  let history = useHistory();
  /** */
  useEffect(() => {
    let timeout = setTimeout(() => {
      //mic test
      initiateMic()
        .then(() => {
          setMicStatus({ finished: true, mic: "success" });
        })
        .catch((err) => {
          setError((error) => ({ ...error, mic: err }));
          setMicStatus({ finished: true, mic: "failed" });
        });

      //speed test
      speedTest()
        .then((result) => {
          console.log(result);
          setValues((values) => ({
            ...values,
            internet: `${result.kbPerSec} kbps`,
          }));
          if (!result.isSlow) {
            console.log("Your internet is great!");
            setInternetStatus({ finished: true, internet: "success" });
          } else {
            setInternetStatus({ finished: true, internet: "success" });
          }
        })
        .catch((error) => {
          if (error.hasFailed) {
            setError((error) => ({
              ...error,
              internet: "Too bad, your internet connection is bad...",
            }));
            console.log("Too bad, your internet connection is bad...");
            setInternetStatus({ finished: true, internet: "failed" });
          }
        });

      //webcam test
      initiateWebCam()
        .then(() => {
          setWebCamStatus({ finished: true, webCam: "success" });
        })
        .catch((err) => {
          setError((error) => ({ ...error, webCam: err }));
          setWebCamStatus({ finished: true, webCam: "failed" });
        });

      //browser test
      browserTest()
        .then((value) => {
          setValues((values) => ({ ...values, browser: value }));
          setBrowserStatus({ finished: true, browser: "success" });
        })
        .catch((err) => {
          setError((errors) => ({ ...errors, browser: err }));
          setBrowserStatus({ finished: true, browser: "failed" });
        });

      return () => clearTimeout(timeout);
    }, 3000);
  }, [reset]);

  const checkFinished = () =>
    webCamStatus.finished &&
    micStatus.finished &&
    browserStatus.finished &&
    internetStatus.finished;

  const checkAllSuccess = () => {
    return (
      webCamStatus.webCam === "success" &&
      micStatus.mic === "success" &&
      browserStatus.browser === "success" &&
      internetStatus.internet === "success"
    );
  };
  const checkAnyFailed = () => {
    return (
      webCamStatus.webCam === "failed" ||
      micStatus.mic === "failed" ||
      browserStatus.browser === "failed" ||
      internetStatus.internet === "failed"
    );
  };
  const handleProceed = () => {
    const path = "/authentication";
    if (checkFinished() && checkAllSuccess()){ 
      dispatch(addRoute(path));
      history.push(path);
    }
  };

  const handleRetry = () => {
    setMicStatus({ finished: false, mic: "loading" });
    setWebCamStatus({ finished: false, webCam: "loading" });
    setInternetStatus({ finished: false, internet: "loading" });
    setBrowserStatus({ finished: false, browser: "loading" });
    setReset((reset) => !reset);
  };

  return (
    <div>
      <div className="system-check-container bg-white">
        <div className="title border-bottom p-3 ">
          <h6 className="fw-bold text-primary mb-0">System Check</h6>
        </div>
        <div className="p-4 row border-bottom">
          <div className="col-lg-4 border-end">
            <div className="system-status-board">
              <div style={{ width: "13.125rem" }}>
                <div className="d-flex justify-content-start align-items-center mb-4">
                  <SpinnerStatus status={webCamStatus.webCam} />
                  <VideoIcon className="set-icon ms-3" />
                  <p className="mb-0 ms-3">Webcam</p>
                </div>
                <div className="d-flex justify-content-start align-items-center mb-4">
                  <SpinnerStatus status={internetStatus.internet} />
                  <InternetIcon className="set-icon ms-3" />
                  <p className="mb-0 ms-3">Internet Speed</p>
                </div>
                <div className="d-flex justify-content-start align-items-center mb-4">
                  <SpinnerStatus status={micStatus.mic} />
                  <MicIcon className="set-icon ms-3" />
                  <p className="mb-0 ms-3">Microphone</p>
                </div>
                <div className="d-flex justify-content-start align-items-center mb-4">
                  <SpinnerStatus status={browserStatus.browser} />
                  <BrowserIcon className="set-icon ms-3" />
                  <p className="mb-0 ms-3">Browser</p>
                </div>
                {!checkFinished() && (
                  <p className="mt-5 fst-italic">
                    Please Wait your system is in check...
                  </p>
                )}
              </div>
            </div>
          </div>
          <div className="col-lg-8 ps-4">
            <div className="detail-title border-bottom bg-primary mb-5">
              <h6 className="font-weight-bold text-white mb-0">
                System Status
              </h6>
            </div>
            <div className="row">
              <div className="col-4 pe-0">
                <p className="text-info fw-bold">Webcam:</p>
              </div>
              <div className="col-8 px-0">
                <p
                  className={
                    webCamStatus.finished && webCamStatus.webCam === "success"
                      ? "text-success"
                      : webCamStatus.webCam === "failed" &&
                        webCamStatus.finished
                      ? "text-danger"
                      : "text-info fst-italic loading-text"
                  }
                >
                  {webCamStatus.finished && webCamStatus.webCam === "success"
                    ? "Access to web cam is successful"
                    : webCamStatus.webCam === "failed" && webCamStatus.finished
                    ? error.webCam
                    : "loading..."}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-4 pe-0">
                <p className="text-info fw-bold">Internet Speed:</p>
              </div>
              <div className="col-8 px-0">
                <p
                  className={
                    internetStatus.finished &&
                    internetStatus.internet === "success"
                      ? "text-success"
                      : internetStatus.internet === "failed" &&
                        internetStatus.finished
                      ? "text-danger"
                      : "text-info fst-italic loading-text"
                  }
                >
                  {internetStatus.finished &&
                  internetStatus.internet === "success"
                    ? values.internet
                    : internetStatus.internet === "failed" &&
                      internetStatus.finished
                    ? error.internet
                    : "loading..."}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-4 pe-0">
                <p className="text-info fw-bold">Microphone:</p>
              </div>
              <div className="col-8 px-0">
                <p
                  className={
                    micStatus.finished && micStatus.mic === "success"
                      ? "text-success"
                      : micStatus.mic === "failed" && micStatus.finished
                      ? "text-danger"
                      : "text-info fst-italic loading-text"
                  }
                >
                  {micStatus.finished && micStatus.mic === "success"
                    ? "Access to microphone is successful"
                    : micStatus.mic === "failed" && micStatus.finished
                    ? error.mic
                    : "loading..."}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-4 pe-0">
                <p className="text-info fw-bold">Browser Check:</p>
              </div>
              <div className="col-8 px-0">
                <p
                  className={
                    browserStatus.finished &&
                    browserStatus.browser === "success"
                      ? "text-success"
                      : browserStatus.browser === "failed" &&
                        browserStatus.finished
                      ? "text-danger"
                      : "text-info fst-italic loading-text"
                  }
                >
                  {browserStatus.finished && browserStatus.browser === "success"
                    ? values.browser
                    : browserStatus.browser === "failed" &&
                      browserStatus.finished
                    ? error.browser
                    : "loading..."}
                </p>
              </div>
            </div>

            {checkFinished() && checkAllSuccess() ? (
              <div
                className="alert alert-success d-flex border-success align-items-start"
                role="alert"
              >
                <InfoCircle />
                <div className="d-flex flex-column align-items-start">
                  <p className="mb-1 fw-bold">Done</p>
                  <p className="mb-1 fst-italic text-success">
                    system check completed successfully!
                  </p>
                  <p className="mb-0">Proceed to authentication</p>
                </div>
              </div>
            ) : checkFinished() && checkAnyFailed() ? (
              <div className="alert alert-error border-danger" role="alert">
                <div className="d-flex align-items-start">
                  <InfoCircle />
                  <div className="d-flex flex-column align-items-start">
                    <p className="mb-1 fw-bold">Error</p>
                    <p className="mb-1">
                      Kindly check your system and try again
                    </p>
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <Button
                    variant="outline-danger"
                    className="me-2"
                    onClick={handleRetry}
                  >
                    Try Again
                  </Button>
                </div>
              </div>
            ) : (
              <div
                className="alert alert-loading d-flex align-items-start"
                role="alert"
              >
                <div className="d-flex flex-column align-items-start">
                  <p className="mb-1 fst-italic text-secondary">
                    please make sure you are in a very quiet environment for a
                    proper system check.
                  </p>
                  <p className="mb-0">Proceed to authentication</p>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="py-4">
          <div className="d-flex justify-content-end px-4">
            <Button variant="outline-danger" className="me-2">
              Cancel
            </Button>
            <Button
              variant="success"
              className="text-white"
              onClick={handleProceed}
              disabled={!(checkFinished() && checkAllSuccess())}
            >
              Proceed
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SystemCheck;
